module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-BlackCondIt.0f5c815.eot";